import axios from "../../../services/axios-config.js";

export async function getUserBindings({ userId }) {
    const res = await axios.get('/admin/users/bindings', { params: { userId } });
    return res?.data?.bindings || [];
}
